"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/CreateNew/Compose/ToField.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _newChatFlow = require('shared/services/createNew/newChatFlow');

var _Avatar = require('web/components/Avatar');
var _icons = require('./icons');
var _useToSearch = require('./useToSearch');













/* "To:" with a chip per recipient and the search input. */
const ToField = ({ search, resultsId, selectedEntitiesList, inputRef, onRemoveEntity, placeholder }) => {
  const isListOpen = search.hasQuery
  return (
    _react2.default.createElement('div', { className: "compose-row compose-row---to" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}
      , _react2.default.createElement('span', { className: "compose-row--label", id: "compose-to-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}, "To:")
      , _react2.default.createElement('div', { className: "compose-row--value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
        ,  selectedEntitiesList.map(entity => (
          _react2.default.createElement('span', {
            key: entity.entityKey,
            className: entity.entityKey === search.selectedChip ? 'compose-chip compose-chip---selected' : 'compose-chip',
            'data-selected': entity.entityKey === search.selectedChip,
            // A click selects it, as Backspace does; the input keeps focus,
            // so Backspace or Delete then removes it.
            onMouseDown: e => e.preventDefault(),
            onClick: () => search.selectChip(entity.entityKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}

            , _react2.default.createElement(_Avatar.EntityAvatar, { entity: entity, size: 20, className: "compose-chip--avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}} )
            , _react2.default.createElement('span', { className: "compose-chip--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}},  _newChatFlow.chipLabel.call(void 0, entity) )
            , _react2.default.createElement('button', {
              type: "button",
              className: "compose-chip--remove",
              'aria-label': `Remove ${_newChatFlow.chipLabel.call(void 0, entity)}`,
              onClick: () => onRemoveEntity(entity.entityKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}

              , _react2.default.createElement(_icons.CloseIcon, { size: 12, __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}} )
            )
          )
        ))
        /* Sized by what's typed: when that doesn't fit beside the chips it
            takes its own row, and long text (an email) wraps there rather
            than scrolling its start out of sight. */
        , _react2.default.createElement('span', {
          className: selectedEntitiesList.length && !search.query ? 'compose-row--grow compose-row--grow---compact' : 'compose-row--grow',
          'data-value': search.query, __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}

          , _react2.default.createElement('textarea', {
            ref: inputRef,
            rows: 1,
            cols: 1,
            role: "combobox",
            'aria-label': "To",
            'aria-expanded': isListOpen,
            'aria-controls': resultsId,
            'aria-autocomplete': "list",
            'aria-activedescendant': isListOpen && search.options[search.active] ? _useToSearch.searchOptionId.call(void 0, search.active) : undefined,
            className: "compose-row--input",
            placeholder: selectedEntitiesList.length ? undefined : placeholder,
            value: search.query,
            // A pasted line break is a space: To is one line of text.
            onChange: e => search.setQuery(e.target.value.replace(LINE_BREAKS, ' ')),
            onKeyDown: search.onKeyDown,
            onKeyUp: search.onKeyUp,
            onBlur: search.deselectChip,
            // A selected chip stands in for the caret, as in WhatsApp.
            style: search.selectedChip ? HIDDEN_CARET : undefined,
            autoComplete: "off",
            spellCheck: false, __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
          )
        )
      )
      ,  search.inviteModal 
    )
  )
}

const HIDDEN_CARET = { caretColor: 'transparent' }
const LINE_BREAKS = /\r?\n/g

exports. default = _react.memo.call(void 0, ToField)
